module.exports = __webpack_public_path__ + "static/img/stay_informed_legally.8d63693a.png";